import { ProgramType } from './ProgramTypes';

export enum WarrantyType {
  equipment = 'equipment',
  accessories = 'accessories',
  zoning = 'zoning',
  ductlessMiniSplit = 'ductlessMiniSplit',
}

export enum WarrantyPaymentFrequency {
  upfront = 'upfront',
  // monthly = 'monthly', // TODO: Coming soon
}

type WarrantyMap = {
  [key in ProgramType]: {
    [type in WarrantyType]?: string;
  };
};

export const warrantyMap: WarrantyMap = {
  [ProgramType.solar]: {},
  [ProgramType.doePr]: {},
  [ProgramType.hvac]: {
    [WarrantyType.equipment]: 'Equipment Warranty',
    [WarrantyType.accessories]: 'Accessories Warranty',
    [WarrantyType.zoning]: 'Zoning Warranty',
    [WarrantyType.ductlessMiniSplit]: 'Ductless Mini Split Warranty',
  },
  [ProgramType.waterHeater]: {
    [WarrantyType.equipment]: 'Equipment Warranty',
  },
  [ProgramType.generator]: {
    [WarrantyType.equipment]: 'Equipment Warranty',
  },
  [ProgramType.geothermal]: {
    [WarrantyType.equipment]: 'Equipment Warranty',
  },
  [ProgramType.newCommunity]: {},
  [ProgramType.newHomes]: {},
  [ProgramType.energyBackup]: {},
  [ProgramType.consumerSolar]: {},
} as const;

export enum WarrantyProvider {
  onPointWarranty = 'OnPoint',
  jbWarranties = 'JB Warranties',
  AIG = 'AIG',
  larsonAssurance = 'Larson Assurance',
  coolCare = 'CoolCare',
  trinity = 'Trinity',
}

export const OnPointDealerID = 'USPLMETO282';

export interface WarrantyContractSkuTermMapping {
  programType: ProgramType;
  term: number;
  contractSku: string;
}

// Shape returned to non-internal users: term/contractSku stripped, programType kept for row splitting.
export type RedactedWarrantyContractSkuTermMapping = Pick<WarrantyContractSkuTermMapping, 'programType'>;

export const WARRANTY_SKU_PROGRAM_TYPES: ReadonlySet<ProgramType> = new Set([
  ProgramType.hvac,
  ProgramType.waterHeater,
]);

export const EXTENDED_WARRANTY_PROGRAM_TYPES: ReadonlySet<ProgramType> = new Set([
  ProgramType.hvac,
  ProgramType.waterHeater,
  ProgramType.geothermal,
  ProgramType.generator,
]);
